import { createActions } from 'redux-actions'

export const { showBackdropMessage } = createActions(
  {
    SHOW_BACKDROP_MESSAGE: (messages: string[]) => messages
  },
  { prefix: 'MESSAGE' }
)
